<template>
  <div id="popover-template-container">
    <div 
      class="popover-wrapper"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @keydown.esc="close"
    >
      <button 
        type="button"
        class="popover-trigger"
        :aria-expanded="isOpen.toString()"
        aria-haspopup="true"
        @click="toggle"
        @focus="handleFocus"
        @blur="handleMouseLeave"
      >
        <slot name="trigger">
          <i class="fas fa-info info-icon" aria-hidden="true"></i>
        </slot>
      </button>

      <transition name="fade">
        <div 
          v-if="isOpen" 
          :class="['popover-card', `direction-${direction}`]" 
          role="tooltip"
          tabindex="-1"
          @mouseenter="clearAutoCloseTimer"
          @mouseleave="handleMouseLeave"
        >
          <div class="popover-arrow"></div>
          <div class="popover-content">
            <slot></slot>
          </div>
        </div>
      </transition>
    </div>
  </div>

</template>

<script>
export default {
  name: "Popover",
  props: {
    autoCloseDelay: {
      type: Number,
      default: 2000
    },
    direction: {
      type: String,
      default: "bottom",
      validator(value) {
        return ["bottom", "top", "left", "right"].includes(value);
      }
    }
  },
  data() {
    return {
      isOpen: false,
      timer: null
    };
  },
  beforeDestroy() {
    this.clearAutoCloseTimer();
  },
  methods: {
    open() {
      this.clearAutoCloseTimer();
      this.isOpen = true;
    },
    close() {
      this.clearAutoCloseTimer();
      this.isOpen = false;
    },
    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
        this.startAutoCloseTimer();
      }
    },
    handleMouseEnter() {
      this.open();
    },
    handleFocus() {
      this.open();
    },
    handleMouseLeave() {
      this.startAutoCloseTimer();
    },
    startAutoCloseTimer() {
      this.clearAutoCloseTimer();
      this.timer = setTimeout(() => {
        this.isOpen = false;
      }, this.autoCloseDelay);
    },
    clearAutoCloseTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>
